import api from "./axiosConfig"; // Importa la configuración centralizada de axios

// (2026-05-13) Req 2: el parámetro moneda ahora es OPCIONAL. Sin moneda el
// backend devuelve historial de TODAS las monedas (USD + EUR + ...).
export const getExchangeRateHistory = async (filterType) => {
  try {
    const params = {};
    if (filterType) params.moneda = filterType;
    const response = await api.get(`/api/bcv/tasas/historial`, { params });
    return response.data;
  } catch (error) {
    console.error("Error al obtener historial de tasas de cambio:", error);
    throw error;
  }
};

// Obtener todos los clientes
export const getLatestExchangeRateHistory = async (filterType) => {
  try {
    const response = await api.get(`/api/bcv/tasas`); //?moneda=USD&desde=2026-04-01&hasta=2026-04-30
    return response.data; // Devuelve los datos de los clientes
  } catch (error) {
    console.error("Error al obtener la ultima tasa de cambio:", error);
    throw error;
  }
};
